import "./App.css";

import {
  Routes,
  Route,
  Navigate,
  Outlet,
  useLocation,
  useParams,
} from "react-router-dom";
import { AnimatePresence } from "framer-motion";

import Nav from "./Components/Nav/Nav";
import Home from "./Components/Home/Home";
import Projects from "./Components/Projects/Projects";
import Project from "./Components/Project/Project";
import About from "./Components/About/About";
import Contact from "./Components/Contact/Contact";

import { getLang, isValidLang, isRTL, DEFAULT_LANG } from "./i18n";

// validate the :lang segment; redirect unknown languages to the default
const LangLayout = () => {
  const { lang } = useParams();
  const location = useLocation();
  if (!isValidLang(lang)) {
    const rest = location.pathname.split("/").slice(2).join("/");
    return <Navigate to={`/${DEFAULT_LANG}${rest ? "/" + rest : ""}`} replace />;
  }
  return <Outlet />;
};

function App() {
  const location = useLocation();
  const { pathname } = location;
  const lang = getLang(pathname);

  // the back button occupies the top-left on detail pages, so hide the brand there
  const isProjectDetail = /^\/(en|fr|ar)\/projects\/.+/.test(pathname);

  document.documentElement.lang = lang;
  document.documentElement.dir = isRTL(lang) ? "rtl" : "ltr";

  return (
    <>
      <Nav theme="dark" showBrand={!isProjectDetail} />

      <AnimatePresence mode="wait">
        <Routes location={location} key={pathname}>
          <Route path="/" element={<Navigate to={`/${DEFAULT_LANG}`} replace />} />
          <Route path="/:lang" element={<LangLayout />}>
            <Route index element={<Home />} />
            <Route path="projects" element={<Projects />} />
            <Route path="projects/:slug" element={<Project />} />
            <Route path="about" element={<About />} />
            <Route path="contact" element={<Contact />} />
          </Route>
          <Route path="*" element={<Navigate to={`/${DEFAULT_LANG}`} replace />} />
        </Routes>
      </AnimatePresence>
    </>
  );
}

export default App;
